// src/components/FrontendHealthCheck.js
import React from 'react';

function FrontendHealthCheck() {
  return (
    <div style={{ backgroundColor: 'white', height: '100vh', display: 'flex', justifyContent: 'left', alignItems: 'left' }}>
      <p style={{ margin: 0, fontFamily: 'sans-serif', fontSize: '16px' }}>Status: ok</p>
    </div>
  );
}

export default FrontendHealthCheck;
